'use client';

import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { IconKey } from '@nx-frontend/shared/types/icon';
import { ImageType } from '@nx-frontend/shared/types/image-selector';
import { parseImage } from '@nx-frontend/shared/utils';
import { EmojiView } from './emoji-view';

interface ImageViewProps {
  image: string;
  className?: string;
}

export function ImageView({ image, className, ...props }: ImageViewProps) {
  const { type, value } = parseImage(image);
  return type === ImageType.EMOJI ? (
    <EmojiView unified={value} className={className} {...props} />
  ) : type === ImageType.ICON ? (
    <Icon icon={IconsMap[value as IconKey]} className={className} {...props} />
  ) : type === ImageType.URL ? (
    <img src={value} className={className} alt="" {...props} />
  ) : null;
}
